import axios from "axios";
import { config } from "./config";

export const api = axios.create({
  baseURL: `${config.apiBaseUrl}/api/v1`,
  withCredentials: true,
});

api.interceptors.request.use((cfg) => {
  const token = sessionStorage.getItem("candidateToken");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});
